import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';
import WineriesList from '../../common/Wineries';

const Wineries = () => (
  <StyledSection>
    <WineriesList />
  </StyledSection>
);

const StyledSection = styled(Section)`
  margin-bottom: 250px;
`;

export default Wineries;
